// src/App.js
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

// Component Imports
import CustomNavbar from './components/Navbar/Navbar';
import HeroSection from './components/Hero/Hero';
import AboutSection from './components/About/About';
import WhatWeDo from './components/WhatWeDo/WhatWeDo';
import ProductSection from './components/Products/Products';
import Certificates from './components/Certificates/Certificates';
import JourneySection from './components/Journey/Journey';
import Facilities from './components/Facilities/Facilities';
import Management from './components/Management/Management';
import ContactFooter from './components/ContactFooter/ContactFooter';
import ClientSection from './components/Clients/Clients';

// Import Image
import whatsappImg from './assets/whatsapp.png'; // Ensure this file exists!

function App() {
  return (
    <div className="App">
      <CustomNavbar />
      <HeroSection />
      <AboutSection/>
      <ClientSection/>
      <WhatWeDo/>
      <ProductSection/>
      <Certificates/>
      <Facilities/>
      <JourneySection/>
      <Management/>
      <ContactFooter/>
      
      {/* WhatsApp Floating Button */}
      <a 
        href="https://wa.me/911234567890" 
        className="whatsapp-float" 
        target="_blank" 
        rel="noopener noreferrer"
      >
        <img 
          src={whatsappImg} 
          alt="WhatsApp Chat" 
          style={{ width: "60px", height: "60px" }} 
        />
      </a>
    </div>
  );
}

export default App;